import { Constants } from '../common/Constants';
import * as InternalTypes from '../common/InternalTypes';
import { LoggerTexts } from '../common/LoggerTexts';
import { Util } from '../common/Util';

export class AppPushState {
	private _areaId: string;
	private _triggerName: string;
	private _triggerType: string;
	private _triggeredCount = 0;
	private _executedCount = 0;
	private _lastChanged: number;

	init(areaId: string, triggerName: string, triggerType: string, triggeredCount?: number, executedCount?: number, lastChanged?: number) {
		if (!areaId || Util.stringIsEmpty(areaId)) {
			throw Error(LoggerTexts.APP_PUSH_STATE.CTOR_AREA_ID_NOT_PROVIDED);
		}
		if (!triggerName || Util.stringIsEmpty(triggerName)) {
			throw Error(LoggerTexts.APP_PUSH_STATE.CTOR_TRIGGER_NAME_NOT_PROVIDED);
		}
		if (!triggerType) {
			throw Error(LoggerTexts.APP_PUSH_STATE.CTOR_TRIGGER_TYPE_NOT_PROVIDED);
		}
		this._areaId = areaId;
		this._triggerName = triggerName;
		this._triggerType = triggerType;
		this._triggeredCount = triggeredCount ?? 0;
		this._executedCount = executedCount ?? 0;
		this._lastChanged = lastChanged ?? Date.now();
	}

	initFromJsonObject(appPushState: InternalTypes.AppPushState) {
		const { areaId, triggerName, triggerType, triggeredCount, executedCount, lastChanged } = appPushState;
		this.init(areaId, triggerName, triggerType, triggeredCount, executedCount, lastChanged);
	}

	get combinedKey(): string {
		return Util.getCombinedKey(this._areaId, this._triggerName);
	}

	get areaId(): string {
		return this._areaId;
	}

	get triggerName(): string {
		return this._triggerName;
	}

	get triggerType(): string {
		return this._triggerType;
	}

	get triggeredCount(): number {
		return this._triggeredCount;
	}

	get executedCount(): number {
		return this._executedCount;
	}

	get lastChanged(): number {
		return this._lastChanged;
	}

	set lastChanged(lastChanged: number) {
		this._lastChanged = lastChanged;
	}

	increaseTriggeredCount() {
		this._triggeredCount++;
		this.lastChanged = Date.now();
	}

	increaseExecutedCount() {
		this._executedCount++;
		this.lastChanged = Date.now();
	}

	hasReachedExpiryDate(): boolean {
		if (!Number.isInteger(this.lastChanged)) {
			this.lastChanged = Date.now();
			return false;
		}
		const timeSinceLastChange = Date.now() - this.lastChanged;
		if (timeSinceLastChange / 86400000 >= Constants.DEFAULTS.DAYS_UNTIL_STATE_EXPIRY) {
			return true;
		}
		return false;
	}

	get appPushStateObject(): InternalTypes.AppPushState {
		const oJsonObject: InternalTypes.AppPushState = {
			areaId: this.areaId,
			triggerName: this.triggerName,
			triggerType: this.triggerType,
			lastChanged: this.lastChanged
		};
		if (this.triggeredCount >= 0) {
			oJsonObject.triggeredCount = this.triggeredCount;
		}
		if (this.executedCount >= 0) {
			oJsonObject.executedCount = this.executedCount;
		}
		return oJsonObject;
	}
}
